import { Text, TextStyles } from '@cinch-labs/design-system'
import type { StoryblokImage } from '@cinch-nx/data-storyblok'
import cx from 'classnames'
import Image from 'next/legacy/image'
import styles from './review-card.module.css'
import { StarRating } from '../star-rating'

export interface ReviewCardProps {
  title: string
  image: StoryblokImage
  starRating: string
  snippet?: string
  featured?: boolean
}

export const ReviewCard: React.FC<ReviewCardProps> = ({
  title = '',
  image,
  starRating = '',
  snippet = '',
  featured = false,
}) => (
  <article
    className={cx(styles.root, {
      [styles.topCard]: featured,
    })}
    data-featured={featured}
    data-uid={title}
  >
    <div
      className={cx(styles.imageContainer, {
        [styles.featured]: featured,
      })}
    >
      <Image
        className={styles.image}
        alt={image?.alt ?? ''}
        src={
          image?.filename ||
          `${
            process.env['STAGE_NAME'] === 'local' ? '' : process.env.STAGE_URL
          }/image-coming-soon.svg`
        }
        layout="fixed"
        width={featured ? 400 : 250}
        height={featured ? 253 : 158}
        priority={featured}
      />
    </div>

    <div>
      <Text
        type={featured ? TextStyles.vehicleTitle : TextStyles.mainTitle}
        element="h2"
        className={styles.title}
        lineHeight="display"
      >
        {title}
      </Text>
      <StarRating starRating={+starRating} />
      {snippet && (
        <Text element="p" className={styles.snippet}>
          {snippet}
        </Text>
      )}
    </div>
  </article>
)
